import { PlatformLogo } from '@/components/atoms/PlatformLogo';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import type { KnownPlatform } from '@/lib/platformTypes';
import { ArrowRight, Trash2 } from 'lucide-react';
import type { CSSProperties } from 'react';

type Props = {
	platform: KnownPlatform;
	forgetLabel: string;
	onSelect: (subdomain: string) => void;
	onForget: (platform: KnownPlatform) => void;
};
export function PlatformCard({ platform, forgetLabel, onSelect, onForget }: Props) {
	return (
		<div
			className="relative"
			style={{ '--platform-color': platform.primaryColor } as CSSProperties}
		>
			<span
				className="absolute inset-y-0 left-0 w-2 rounded-l-[4px] bg-[var(--platform-color)]"
				aria-hidden="true"
			/>
			<Card className="relative ml-1 flex items-center gap-3 rounded-l-none rounded-r-[4px] border-[#dce7e3] p-1.5 shadow-none">
				<button
					className="flex min-w-0 flex-1 cursor-pointer items-center gap-3 border-0 bg-transparent p-2 text-left text-inherit"
					onClick={() => onSelect(platform.subdomain)}
				>
					<PlatformLogo
						name={platform.name}
						logo={platform.logo}
						color={platform.primaryColor}
					/>
					<span className="grid min-w-0 flex-1 gap-1">
						<strong className="truncate text-[#1a2925]">{platform.name}</strong>
						<small className="truncate text-[#71817c]">{platform.host}</small>
					</span>
					<ArrowRight className="text-[var(--platform-color)]" />
				</button>
				<Button
					variant="ghost"
					size="sm"
					className="cursor-pointer text-xs text-[#82918d] hover:bg-transparent hover:text-[#bd4b4b] max-sm:size-9 max-sm:px-0"
					onClick={() => onForget(platform)}
					aria-label={`${forgetLabel} ${platform.name}`}
				>
					<Trash2 className="size-4 sm:hidden" />
					<span className="hidden sm:inline">{forgetLabel}</span>
				</Button>
			</Card>
		</div>
	);
}
